import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthService } from '@klickdata/core/auth';
import { MobileService } from '@klickdata/core/mobile';
import { ResourceSelectComponent } from '@klickdata/shared-components/src/selection-handler/resources-assign/resource-select/resource-select.component';
import { ResourceSelectDatatableService } from '../resource-select-datatable.service';

@Component({
    selector: 'app-customer-manager-resources-select',
    templateUrl: './customer-manager-resources-select.component.html',
    styleUrls: ['./customer-manager-resources-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ResourceSelectDatatableService],
})
export class CustomerManagerResourcesSelectComponent extends ResourceSelectComponent {
    constructor(
        public datatableService: ResourceSelectDatatableService,
        protected mobileService: MobileService,
        protected auth: AuthService
    ) {
        super(datatableService, mobileService, auth);
    }

    detectIdKeyValueChange() {
        this.refresh(this.customer_id);
    }
    public refresh(id?: any): void {
        const filters: Array<{ property: string; items: (string | number)[] }> = [
            { property: 'scope', items: [this.scope_id] },
        ];
        // const filters = [{ property: 'scope', items: [this.scope_id] }];
        if (this.referenceFilter) {
            filters.push({ property: this.referenceFilter, items: [id ?? 'null'] });
        }
        if (!!this.eager?.length) {
            filters.push({ property: 'eager', items: this.eager });
        }
        this.filter?.createOrUpdateWithoutEmitFilter(filters);
    }
}
